import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { AuthProvider } from './app/AuthProvider.tsx';
import { PreferencesProvider } from './app/PreferencesProvider.tsx';
import '@fontsource-variable/nunito/wght.css';
import './styles/app.css';

// No right-click / long-press menu anywhere on the site. Text fields keep it so
// kids can still paste a room code or a name. (Right-drag arrows on the board
// use mouse events and keep working.)
document.addEventListener('contextmenu', (event) => {
  const target = event.target as HTMLElement | null;
  if (target?.closest('input, textarea, [contenteditable="true"]')) return;
  event.preventDefault();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PreferencesProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </PreferencesProvider>
  </StrictMode>,
);
